<i class="fa fa-times" (click)="close()" style="float: right;cursor: pointer;"></i>

<div class="review mt-3" *ngFor="let review of ratinglist">
    <div>
        <div class="d-flex justify-content-between">
            <div><i class="fas fa-solid fa-user"></i> {{review.email.split('@')[0]}} </div>
            <div><i class="fa fa-star" aria-hidden="true"></i>{{review.rating}}/5</div>
        </div>

        <div>{{review.comments}}</div>
        <hr>
    </div>
</div>